@if (distribution) {
  @if (company_product) {
    <h1 mat-dialog-title>
      <span [matTooltip]="distribution.is_active ? 'Distribución acitva' : 'Distribución futura'">
        {{ distribution.is_active ? '🟢' : '🔵' }}
      </span>

      Distribución de tiempo: {{ company_product.title }}
    </h1>
  }

  @if (form) {
    <mat-dialog-content class="container" [formGroup]="form">
      <div class="row" formArrayName="distributions">
        @for (control of getDistributionsArray().controls; track control; let i = $index) {
          <div class="col-12 col-lg-4" [formGroupName]="i">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold">{{ control.value.company_product_phase_name }}</span>
              @if (!data.is_view) {
                <button mat-icon-button [matMenuTriggerFor]="menu" class="small-icon-button">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onClickRemovePhase(i)">
                    <mat-icon>delete</mat-icon>
                    <span>Eliminar fase</span>
                  </button>
                </mat-menu>
              }
            </div>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="time_prcnt" type="number" min="0" max="100" />
              <mat-icon matIconSuffix>percent</mat-icon>
            </mat-form-field>
          </div>
        }
      </div>

      <!-- Total y mensaje de error -->
      @if (!data.is_view) {
        <div class="row mt-3">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted"
                >Total: <strong>{{ getCurrentTotal() }}%</strong></span
              >
              @if (getSumError()) {
                <span class="text-danger" style="display: inline-flex; align-items: center; gap: 5px">
                  <mat-icon>error</mat-icon>
                  {{ getSumError() }}
                </span>
              } @else if (getCurrentTotal() === 100) {
                <span class="text-success" style="display: inline-flex; align-items: center; gap: 5px">
                  <mat-icon>check_circle</mat-icon>
                  Distribución completa
                </span>
              }
            </div>
          </div>
        </div>
      }
    </mat-dialog-content>

    @if (!data.is_view) {
      <mat-dialog-actions align="end">
        <button mat-stroked-button style="margin-right: auto" color="accent" (click)="onClickAddPhase()">
          <mat-icon>add_circle</mat-icon>
          Añadir fase
        </button>
        <button mat-flat-button (click)="close()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>

        <button mat-flat-button color="accent" (click)="save()" [disabled]="!form.valid">
          <mat-icon>done</mat-icon>
          Guardar
        </button>
      </mat-dialog-actions>
    }
  }
}
